import { render } from "./CourseSidebar.vue?vue&type=template&id=eb57956c&ts=true"
import script from "./CourseSidebar.vue?vue&type=script&lang=ts"
export * from "./CourseSidebar.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__